import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogSectionComponent } from './catalog-section/catalog-section.component';
import {
  CatalogDetailComponent,
  CatalogDetailResolver
} from './catalog-detail/catalog-detail.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
  {
    path: 'section/:code',
    component: CatalogSectionComponent,
  },
  {
    path: 'section/:code/:filterTag',
    component: CatalogSectionComponent,
  },
  {
    path: ':code',
    component: CatalogDetailComponent,
    resolve: {data: CatalogDetailResolver}
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  providers: [
    CatalogDetailResolver,
  ],
  exports: [
    RouterModule
  ]
})
export class CatalogRouterModule {}
